import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { accessPermitted } from '@/shared/components/helpers';
import { RouteN } from '../constants/router-name';
import AutoLogin from '../components/auto-login/index.vue';
import Logout from '../components/logout/index.vue';
import NoAccess from '../components/no-access/index.vue';
import AtscMain from '../components/atcs-main/index.vue';
import AtcsImpersonate from '../components/atcs-impersonate/index.vue';
import { AuthorizedUser } from '../models/authorized-user';
import store from '../store';
import { RoleType } from '../models/user';
import AppDashboard from '../components/app-dashboard/index.vue';
import FormPartA from '../components/form-part-a/index.vue';
import FormPartB from '../components/form-part-b/index.vue';
import FormEer from '../components/form-eer/index.vue';
import EESignup from '../components/ee-signup/index.vue';
import EEDashboard from '../components/ee-dashboard/index.vue';
import AtcsDashboard from '../components/atcs-dashboard/index.vue';
import EEInactive from '../components/ee-inactive/index.vue';
import ManagedAuthorisedSignatories from '../components/manage-authorised-signatories/index.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: RouteN.ATCS.LoginPage.p,
    name: RouteN.ATCS.LoginPage.n,
    component: AutoLogin,
  },
  {
    path: RouteN.ATCS.LogoutPage.p,
    name: RouteN.ATCS.LogoutPage.n,
    component: Logout,
  },
  {
    path: RouteN.NoAccess.p,
    name: RouteN.NoAccess.n,
    component: NoAccess,
  },
  {
    path: RouteN.ATCS.Main.p,
    meta: {
      requiresAuth: true,
      rolesAllowed: RouteN.ATCS.Main.r
    },
    name: RouteN.ATCS.Main.n,
    component: AtscMain,
    children: [
      {
        path: RouteN.ATCS.ImpersonateUser.p,
        name: RouteN.ATCS.ImpersonateUser.n,
        meta: {
          rolesAllowed: RouteN.ATCS.ImpersonateUser.lt
        },
        component: AtcsImpersonate,
      },
      {
        path: RouteN.ATCS.DashboardMain.p,
        name: RouteN.ATCS.DashboardMain.n,
        component: AppDashboard,
        children: [
          {
            path: RouteN.ATCS.DashboardHome.p,
            name: RouteN.ATCS.DashboardHome.n,
            component: AtcsDashboard,
          },
          {
            path: RouteN.ATCS.EEHome.p,
            name: RouteN.ATCS.EEHome.n,
            component: EEDashboard,
          },
          {
            path: RouteN.ATCS.EESignUp.p,
            name: RouteN.ATCS.EESignUp.n,
            component: EESignup,
          },
          {
            path: RouteN.ATCS.EEInactive.p,
            name: RouteN.ATCS.EEInactive.n,
            component: EEInactive,
          },
          {
            path: RouteN.ATCS.FormPartA.p,
            name: RouteN.ATCS.FormPartA.n,
            component: FormPartA,
          },
          {
            path: RouteN.ATCS.FormPartB.p,
            name: RouteN.ATCS.FormPartB.n,
            component: FormPartB,
          },
          {
            path: RouteN.ATCS.FormEer.p,
            name: RouteN.ATCS.FormEer.n,
            component: FormEer,
          },
          {
            path: RouteN.ATCS.ManageAuthorisedSignatories.p,
            name: RouteN.ATCS.ManageAuthorisedSignatories.n,
            component: ManagedAuthorisedSignatories,
            meta: {
              rolesAllowed: RouteN.ATCS.ManageAuthorisedSignatories.lt
            },
          },
        ]
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach((to) => {
  const authUser: AuthorizedUser = store.getters.getUserAccount;
  const routeRoles: any[] = to.meta.rolesAllowed as any[] || []

  try {
    if (to.matched.length >= 2 && (to.matched[1].name as any) != RouteN.ATCS.ImpersonateUser.n && routeRoles.filter(y => y == authUser.user.lawIdUserTypeId).length == 0) {
      // router.replace({ name: RouteN.NoAccess.n });
    }
  } catch (error) {
    console.log(error);
  }



  // else if (to.matched.length >= 2 && (to.matched[1].name as any) == RouteN.ATCS.ImpersonateUser && !authUser.user.isTester) {
  //   router.replace({ name: RouteN.NoAccess.n });
  // }

  // if (to.matched.length >= 2 && !accessPermitted(
  //   authUser.user.lawIdUserTypeId as any, to.meta.rolesAllowed as any[])) {
  //   router.replace({ name: RouteN.NoAccess.n });
  // }
});

export default router